// extracted by mini-css-extract-plugin
export default {"loadingGroup":"loadingGroup--_bJG3","switch":"switch--N189J"};